import React from "react";

/* Seats around one round table — the forum, seen from above. */
const SEAT_COUNT = 8;
const SEATS = Array.from({ length: SEAT_COUNT }, (_, i) => {
  const a = (-90 + i * (360 / SEAT_COUNT)) * (Math.PI / 180);
  return { x: 24 + 20 * Math.cos(a), y: 24 + 20 * Math.sin(a), lit: i === 0 };
});

export const Mark = ({ size = 32, onDark = false, className = "" }) => {
  const disc = onDark ? "#F8FAFC" : "#0f172a";
  const letter = onDark ? "#0f172a" : "#F8FAFC";
  const ring = onDark ? "rgba(248,250,252,.45)" : "rgba(15,23,42,.28)";
  const seat = onDark ? "#F8FAFC" : "#0f172a";
  const accent = "#60a5fa";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      className={`shrink-0 ${className}`}
      aria-label="The Table"
      role="img"
    >
      <circle cx="24" cy="24" r="20" fill="none" stroke={ring} strokeWidth="1" />
      {SEATS.map((s, i) => (
        <circle key={i} cx={s.x} cy={s.y} r={s.lit ? 2.9 : 2.3} fill={s.lit ? accent : seat} />
      ))}
      <circle cx="24" cy="24" r="13.4" fill={disc} />
      <text
        x="24"
        y="24"
        textAnchor="middle"
        dominantBaseline="central"
        fill={letter}
        style={{ font: "600 15px 'EB Garamond', Georgia, serif", letterSpacing: ".5px" }}
      >
        T
      </text>
    </svg>
  );
};

export const Wordmark = ({ size = 34, onDark = false }) => (
  <span className="inline-flex items-center gap-3">
    <Mark size={size} onDark={onDark} />
    <span className="leading-none">
      <span className="block serif text-[17px] tracking-[0.14em] uppercase" style={{ color: onDark ? "#E2E8F0" : "var(--ink-mute)" }}>
        The
      </span>
      <span className="block serif text-[17px] tracking-[0.14em] uppercase" style={{ color: onDark ? "#fff" : "var(--ink)" }}>
        Table
      </span>
    </span>
  </span>
);
